"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Flyout;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _searchResult = _interopRequireDefault(require("./search-result.js"));
var _spinner = _interopRequireDefault(require("../../../elements/other/spinner"));
var _animation = require("../../../animation");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _siteSearchContext = require("../site-search-context");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-wuzg0ei"
});
const ResultsSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ResultsSection",
  class: "pl-r1wrbnqn"
});
const Results = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Results",
  class: "pl-reja2dj"
});
function Flyout({
  label,
  isLoading,
  trackingV2 = false,
  trackingCustomProperties: customProps = {}
}) {
  const [dataResults, setDataResults] = (0, _react.useState)('');
  const [dataUrls, setDataUrls] = (0, _react.useState)('');
  const {
    value,
    list,
    isActive,
    step
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  (0, _react.useEffect)(() => {
    const results = [];
    const urls = [];
    list?.map((item, ix) => {
      if (typeof item === 'string') {
        const result = trackingV2 ? [item, step, ix].join('_') : item;
        results.push((0, _patternLibraryUtils.applySnakeCase)(result));
      } else {
        const result = trackingV2 ? [item, step, ix].join('_') : item?.title;
        item?.title && results.push((0, _patternLibraryUtils.applySnakeCase)(result));
        item?.url && urls.push(item.url);
      }
    });
    const resultsString = results?.length > 0 ? results.join('¬') : '';
    const urlsString = urls?.length > 0 ? urls.join('¬') : '';
    setDataResults(resultsString);
    setDataUrls(urlsString);
  }, [list]);
  const stepMap = {
    initial: 'popular_terms',
    suggestions: 'autocomplete',
    noresults: 'search_suggestions'
  };
  const trackingCustomProperties = {
    ...customProps,
    [trackingV2 ? stepMap[step] : 'sitesearch_results']: dataResults,
    sitesearch_urls: dataUrls,
    sitesearch_term: (0, _patternLibraryUtils.applySnakeCase)(value) || ''
  };
  const trackingName = trackingV2 ? stepMap[step] : `sitesearch_${step}`;
  const trackingProps = (0, _patternLibraryUtils.create)(trackingName, false, false, trackingCustomProperties);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "flyout",
    className: isActive ? 'active' : ''
  }, /*#__PURE__*/_react.default.createElement(ResultsSection, null, value?.trim().length !== 1 ? /*#__PURE__*/_react.default.createElement(Results, (0, _extends2.default)({
    "data-cy": "results"
  }, trackingProps), isLoading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "label",
    size: -1,
    "data-cy": "label",
    className: "text-uppercase",
    text: label
  }), list?.map((title, i) => /*#__PURE__*/_react.default.createElement(_searchResult.default, {
    key: i,
    id: i.toString(),
    title: title,
    style: {
      '--index': i.toString()
    },
    trackingCustomProperties: {
      ...trackingCustomProperties,
      ...(trackingV2 && {
        suggestion_rank: i
      })
    },
    trackingEid: trackingV2 ? trackingName : null
  })))) : null));
}
Flyout.propTypes = {
  label: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  trackingV2: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object
};